export default __webpack_public_path__ + "static/media/plain-sticker-it.9cffafe1.png";